import { styled } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";
import { cssFontSize, cssSpacing } from "../../util/styles.js";
import { SearchBar } from "../Input/SearchBar.js";

export const PageFilterWrapper = styled.div`
  position: relative;
`;

/* ── Mobile ─────────────────────────────────────────── */

export const MobileControls = styled.div<{ $withResultCount?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${cssSpacing("xs")};
  padding-bottom: ${(p) =>
    p.$withResultCount ? p.theme.spacing.xs : p.theme.spacing.s};

  @media (min-width: ${mobileBreakPointCSS}) {
    display: none;
  }
`;

export const FilterToggleButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${cssSpacing("xs")};
  padding: ${cssSpacing("xs")} ${cssSpacing("s")};
  border: 2px solid var(--multiselect-accent-color);
  border-radius: ${(props) => props.theme.borderRadius};
  background: transparent;
  color: var(--multiselect-accent-color);
  font-size: ${cssFontSize("small")};
  font-family: inherit;
  cursor: pointer;

  svg path {
    stroke: var(--multiselect-accent-color);
  }

  svg circle {
    fill: var(--page-filter-background);
  }
`;

export const SearchIconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: 2px solid var(--searchbar-border-color);
  border-radius: ${(props) => props.theme.borderRadius};
  background: transparent;
  cursor: pointer;
`;

export const MobileSearchBar = styled(SearchBar)<{ $withResultCount?: boolean }>`
  margin-bottom: ${(p) =>
    p.$withResultCount ? p.theme.spacing.xs : p.theme.spacing.s};
`;

export const SearchIconWrap = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  svg {
    width: 24px;
    height: 24px;

    path,
    circle {
      stroke: var(--primary-icon-color);
    }
  }
`;

export const MobileFilterPanel = styled.div`
  position: fixed;
  inset: 0;
  height: 100dvh;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  background: var(--page-filter-background);
  overflow: hidden;

  @media (min-width: ${mobileBreakPointCSS}) {
    display: none;
  }
`;

export const MobileFilterTopBar = styled.div`
  padding: ${cssSpacing("s")} ${cssSpacing("xs")} 0 ${cssSpacing("xs")};
`;

export const FilterPanelInner = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin: 0 ${cssSpacing("xs")};
  border-radius: ${(props) => props.theme.borderRadius};
  background: var(--swatch3);
`;

export const FilterPanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${cssSpacing("s")} ${cssSpacing("s")};
`;

export const FilterPanelTitle = styled.span`
  font-size: ${cssFontSize("medium")};
  font-weight: 700;
  color: var(--primary-text-color);
`;

export const ResetButton = styled.button`
  background: transparent;
  border: none;
  color: var(--multiselect-accent-color);
  font-size: ${cssFontSize("small")};
  font-family: inherit;
  cursor: pointer;
  padding: 0;
`;

export const FilterPanelScroll = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: ${cssSpacing("s")};
`;

export const FilterGroupSection = styled.div`
  margin-bottom: ${cssSpacing("m")};
`;

export const FilterGroupLabel = styled.span`
  display: block;
  font-size: ${cssFontSize("tiny")};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--secondary-text-color);
  margin-bottom: ${cssSpacing("xs")};
`;

export const FilterPanelFooter = styled.div`
  padding: 0 ${cssSpacing("s")} ${cssSpacing("s")};

  > button {
    width: 100%;
  }
`;

/* ── Desktop ─────────────────────────────────────────── */

export const DesktopFilterBar = styled.div<{ $withResultCount?: boolean }>`
  display: none;
  padding-bottom: ${(p) =>
    p.$withResultCount ? p.theme.spacing.s : p.theme.spacing.m};

  @media (min-width: ${mobileBreakPointCSS}) {
    display: flex;
    align-items: flex-start;
    gap: ${cssSpacing("m")};
    flex-wrap: wrap;
  }
`;

export const DesktopSearchGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 220px;
  max-width: 400px;
  margin-left: auto;
`;

/* ── Shared ──────────────────────────────────────────── */

export const ResultCount = styled.p`
  margin: 0 0 ${cssSpacing("s")};
  color: var(--secondary-text-color);
  font-size: ${cssFontSize("small")};

  strong {
    font-weight: 700;
  }
`;

